import React from "react";
import {DynamicIcon} from "lucide-react/dynamic";
import MobPressable from "./MobPressable";
import {MOBCOLORS} from "../../configs/AppConfig";


export function MobEditButtonIcon({onClick,icon})
{

    return(
        <MobPressable style={{
            display: "flex",
            alignItems: "center",
            justifyContent:"center",
            backgroundColor: MOBCOLORS.blue.color,
            padding: "5px",
            borderRadius: 25,
            cursor:"pointer",
            boxShadow:"0 2px 4px rgba(0, 0, 0, 0.08)",
        }}
             onClick={onClick}
        >
            <DynamicIcon name={icon || "pen"} color={"#FFF"} size={15}
                         style={{display: "flex", justifyContent: "center", alignItems: "center"}}/>
        </MobPressable>
    )
}
